import { useMemo } from 'react'
import { generatePath, Redirect, Route } from 'react-router-dom'
import Content from 'app/Content'
import {
  reportsDataSearchPath,
  reportsInsightsPath,
  reportsJaqiAiPath,
  reportsMetabaseAccountPath,
  reportsMetabaseCampaignPath,
  reportsPath,
  reportsPerformancePath,
  reportsPersonalizationPath,
} from 'app/navigation/paths'
import CustomSwitch from 'app/router/Switch'
import { useFlags } from 'launchdarkly-react-client-sdk'

import { useAppSelector } from 'common/hooks/redux'
import Personalization from 'features/personalization'

import Dashboard from './dashboard/Dashboard'
import Insights from './insights/Insights'
import Performance from './performance/Performance'

const Reports = () => {
  const {
    showBothReviewAndManage,
    showDataSearch,
    showJaqi,
    showMetabaseLiveboard,
    showReportingV1,
  } = useFlags()

  const accountId = useAppSelector((state) => state.authStates.accountId)

  const performanceSubroute = generatePath(reportsPerformancePath, {
    accountId,
  })
  const insightsSubroute = generatePath(reportsInsightsPath, {
    accountId,
  })
  const personalizationSubroute = generatePath(reportsPersonalizationPath, {
    accountId,
  })

  const reportingPaths = useMemo(() => {
    const paths: string[] = []
    if (showReportingV1) {
      if (showDataSearch) {
        paths.push(reportsDataSearchPath)
      }
      if (showJaqi) {
        paths.push(reportsJaqiAiPath)
      }
    }
    if (showBothReviewAndManage || showMetabaseLiveboard) {
      paths.push(reportsMetabaseAccountPath)
      paths.push(reportsMetabaseCampaignPath)
    }
    return paths
  }, [
    showBothReviewAndManage,
    showDataSearch,
    showJaqi,
    showMetabaseLiveboard,
    showReportingV1,
  ])

  return (
    <CustomSwitch>
      <Route path={reportsPerformancePath}>
        <Content>
          <Performance />
        </Content>
      </Route>
      <Route path={reportsInsightsPath}>
        <Content>
          <Insights />
        </Content>
      </Route>
      <Route path={reportsPersonalizationPath}>
        <Personalization />
      </Route>

      {reportingPaths.length > 0 ? (
        <Route path={reportingPaths}>
          <Dashboard />
        </Route>
      ) : null}

      <Redirect exact from={reportsPath} to={performanceSubroute} />
      <Redirect exact from="/reports" to={performanceSubroute} />
      <Redirect exact from="/reports/performance" to={performanceSubroute} />
      <Redirect exact from="/reports/insights" to={insightsSubroute} />
      <Redirect
        exact
        from="/reports/personalization"
        to={personalizationSubroute}
      />
    </CustomSwitch>
  )
}

export default Reports
